import { useState } from 'react';
import { PropTypes } from 'prop-types';

import { useInView } from 'react-intersection-observer';

import JsonLd from 'Components/Jsonld';
import { breakpoints } from 'Components/ThemeProvider';

import HowItWorks from 'Blocks/HowItWorks';
import Sustainability from 'Blocks/Sustainability';
import Ticker from 'Blocks/Ticker';

import ConsultationCTA from 'Containers/ConsultationCTA';
import ScrollTracker from 'Containers/ScrollTracker';

import BaseScene from 'Scenes/LegacyBaseScene';

import * as content from 'assets/content/home';

import useMedia from 'utils/useMedia';

import AboutUs from './Home/AboutUs';
import CustomersReviewsSkincare from './Home/CustomersReviewsSkincare';
import CustomHaircare from './Home/CustomHaircare';
import CustomSkincare from './Home/CustomSkincare';
import ExploreMore from './Home/ExploreMore';
import HomeHero from './Home/HomeHero';
import PressSlider from './Home/PressSlider';
import UgcBlock from './Home/UgcBlock';
import { HowItWorksModal } from './HowItWorksModal';

const Home = ({ header, footer }) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.sm}px)`);
  const [heroRef, heroInView] = useInView({ threshold: 0.7 });
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <HowItWorksModal isVideoOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} />

      <BaseScene footer={footer} header={header} relativePosition>
        <JsonLd>{content.dataJsonLd}</JsonLd>
        <ScrollTracker>
          <HomeHero ref={heroRef} onOpenVideo={() => setIsVideoOpen(true)} />
          <Ticker content={content.ticker} hasBorder />
          <CustomHaircare />
          <CustomSkincare />
          <AboutUs content={content.aboutUs} />
          <HowItWorks cta dataFrom="block-how-it-works" isSkincare />
          <ExploreMore content={content.exploreMoreContent} />
          <Sustainability content={content.sustainability} />
          <CustomersReviewsSkincare content={content.customersSkincare} />
          <PressSlider content={content.press} />
          <UgcBlock content={content.ugc} />
          {isMobile && !heroInView && (
            <ConsultationCTA dataFrom="sticky-footer" fixed theme="vert" />
          )}
        </ScrollTracker>
      </BaseScene>
    </>
  );
};

Home.defaultProps = {
  footer: true,
  header: true,
};

Home.propTypes = {
  footer: PropTypes.bool,
  header: PropTypes.bool,
};

export default Home;
